import {
  Card,
  CardBody,
  CardHeader,
  stenaPerformance,
} from "@stenajs-webui/elements";
import { Box } from "@stenajs-webui/core";
import { GapValues } from "@/lib/utils/GapValues";
import _ from "lodash";
import { AgreedVolumePerformanceTable } from "./AgreedVolumePerformanceTable";
import { useAgreedVolumePerformanceByCustomer } from "../../hooks/UseAgreedVolumePerformanceByCustomer";
import { Select } from "@stenajs-webui/select";
import { useState } from "react";
import { SingleValue } from "react-select";

const yearAsOption = (year: number, offset = 0) => ({
  value: year - offset,
  label: `${year - offset}`,
});

interface Props {
  customerId: string;
}

export const AgreedVolumeSummaryCard = ({ customerId }: Props) => {
  const currentYear = new Date().getFullYear();
  const yearOptions = [
    yearAsOption(currentYear, -1),
    yearAsOption(currentYear),
    yearAsOption(currentYear, 1),
  ];

  const [selectedYear, setSelectedYear] = useState<
    SingleValue<{ value: number; label: string }>
  >(yearOptions[1]);

  const { agreedVolumePerformance, loading } =
    useAgreedVolumePerformanceByCustomer(
      parseInt(customerId),
      selectedYear?.value || currentYear
    );

  return (
    <Card>
      <CardHeader
        text="Agreed volume"
        leftIcon={stenaPerformance}
        contentRight={
          <Select
            options={yearOptions}
            value={selectedYear}
            onChange={(newValue) => setSelectedYear(newValue)}
          />
        }
      />
      <CardBody>
        <Box gap={GapValues.SIXTEEN}>
          <AgreedVolumePerformanceTable
            data={agreedVolumePerformance?.performanceByRouteCode}
            loading={loading}
          />
        </Box>
      </CardBody>
    </Card>
  );
};
